import React, { useEffect, useContext, useState, lazy, Suspense, useCallback } from 'react';
import { getAllServiceAgentDash } from '../../../Core/Services/ServiceAgent/ServiceAgent';
import '../ServiceCommon.scss';
import moment from 'moment';

const LazyComponent = lazy(() => import('../../Technician/dashboardUserInterface'));

const MainDashboard = (props) => (
    <Suspense fallback={<div>please Wait...</div>}>
        <LazyComponent {...props} />
    </Suspense>
);

const ServiceAgentDash = () => {
    const [dashboardData, setDashboardData] = useState([]);
    const [loading, setLoading] = useState(true);

    const pullDashboardData = useCallback(async () => {
        try {
            setLoading(true); // Start loading
            const res = await getAllServiceAgentDash();

            if (res.success) {
                setDashboardData(res.data.dashboard[0]);
            } else {
                console.warn('Unexpected response:', res);
            }
        } catch (error) {
            console.error('API Error:', error.response.data);
        } finally {
            setLoading(false); // Stop loading once data is fetched
        }
    }, []);

    useEffect(() => {
        pullDashboardData();
    }, [pullDashboardData]);

    const singleGrpupCardData = [
        {
            title: 'Overview',
            objList: [
                {
                    name: 'Unallocated ',
                    value: dashboardData.jobsUnallocated,
                    // background: 'linear-gradient(110deg, #fc4a1a 0%,#eb856a 100%)',
                    path: '/serviceagent/OJ',
                    params: {},
                    search: `?vehicleJobStatus=Unallocated`,
                    valueColor: '#0096FF',
                    xl: 1
                },
                {
                    name: 'Not Started ',
                    value: dashboardData.jobsNotStarted,
                    // background: 'linear-gradient(110deg, #fc4a1a 0%,#eb856a 100%)',
                    path: '/serviceagent/OJ',
                    params: {},
                    search: `?vehicleJobStatus=Not Started`,
                    valueColor: '#0096FF',
                    xl: 1
                },
                {
                    name: 'Onhires',
                    value: dashboardData.onHireService,
                    path: '/Contracts_Hire_Fleet',
                    search: `?fromDash=true&status=Vehicle Onsite`,
                    params: {},
                    xl: 1
                },
                {
                    name: 'Offhires',
                    value: dashboardData.offHireService,
                    path: '/Contracts_Hire_Fleet',
                    search: `?fromDash=true&status=Off Hire`,
                    params: {},
                    xl: 1
                },
                {
                    name: 'Breakdown',
                    value: dashboardData.breakdowns,
                    // background: 'linear-gradient(110deg, #F00000 0%,#f27272 100%)',
                    path: '/maintenance/breakdowns/:all',
                    valueColor: 'red',
                    params: {},
                    xl: 1
                },
                {
                    name: 'VOR',
                    value: dashboardData.vor,
                    //  background: 'linear-gradient(110deg, #fc4a1a 0%,#eb856a 100%)',
                    path: '/controller/vor',
                    valueColor: 'red',
                    params: {},
                    xl: 1
                }
            ],
            itemSize: {
                lg: 4,
                md: 2,
                sm: 2,
                xs: 'auto'
            }
        }
    ];

    const groupCardData = [
        {
            title: 'JOBS',
            headBackground: '#FA7070',
            // background: 'linear-gradient(110deg,#1D976C 40%,#93F9B9 100%)',

            // path: '/serviceagent/OJ',
            items: [
                { label: 'All jobs', value: dashboardData.jobsTotal, path: '/serviceagent/OJ', params: { vehicleJobStatus: '' } },
                {
                    label: 'Awaiting Parts',
                    value: dashboardData.jobsAwaitingParts,
                    path: '/serviceagent/OJ',
                    params: {},
                    search: `?showAllRecords=3&vehicleJobStatus=Awaiting Parts`
                },
                {
                    label: 'Paused',
                    value: dashboardData.jobsPaused,
                    path: '/serviceagent/OJ',
                    params: {},
                    search: `?showAllRecords=3&vehicleJobStatus=Paused`
                },
                {
                    label: 'Work in progress',
                    value: dashboardData.jobsWIP,
                    path: '/serviceagent/OJ',
                    params: {},
                    search: `?showAllRecords=3&vehicleJobStatus=Work In Progress`
                }
            ],
            cardSize: {
                lg: 6,
                md: 12,
                sm: 12,
                xs: 12
            },
            itemSize: {
                lg: 3,
                md: 3,
                sm: 3,
                xs: 6
            }
        },
        {
            title: 'EVENTS',
            // path: '/schedule/confirmedbookings',
            items: [
                {
                    label: 'Overdue',
                    value: dashboardData.scheduleOverdue,
                    path: `/schedule/confirmedbookings`,
                    search: `?fromDash=true&end=${moment().subtract(1, 'weeks').endOf('isoWeek').format('YYYY-MM-DD')}`,
                    valueColor: 'red'
                },
                {
                    label: 'This Week',
                    value: dashboardData.scheduleThisWeek,
                    path: `/schedule/confirmedbookings`,
                    params: {},
                    search: `?fromDash=true&start=${moment().startOf('isoWeek').format('YYYY-MM-DD')}&end=${moment().endOf('isoWeek').format('YYYY-MM-DD')}`
                },
                {
                    label: 'Next Week',
                    value: dashboardData.scheduleNextWeek,
                    path: `/schedule/confirmedbookings`,
                    params: {},
                    search: `?fromDash=true&start=${moment().add(1, 'weeks').startOf('isoWeek').format('YYYY-MM-DD')}&end=${moment()
                        .add(1, 'weeks')
                        .endOf('isoWeek')
                        .format('YYYY-MM-DD')}`
                },
                {
                    label: 'Future',
                    value: dashboardData.scheduleFuture,
                    params: {},
                    path: `/schedule/confirmedbookings`,
                    search: `?fromDash=true&start=${moment().add(2, 'weeks').startOf('isoWeek').format('YYYY-MM-DD')}`
                }
            ],
            cardSize: {
                lg: 3,
                md: 12,
                sm: 12,
                xs: 12
            },
            itemSize: {
                lg: 6,
                md: 3,
                sm: 3,
                xs: 6
            }
        },
        {
            title: 'Allocations',
            // background: 'linear-gradient(110deg,#1D976C 40%,#93F9B9 100%)',
            // path: '/Contracts_Hire_Fleet',
            // itemSize: {
            //     lg: 12,
            //     md: 12,
            //     sm: 12,
            //     xs: 6
            // },

            items: [
                { label: 'Hire Vehicles', value: dashboardData.hireActive, path: '/Contracts_Hire_Fleet', params: {} },
                { label: 'Contract Maintenance', value: dashboardData.contractMaintenanceActive, path: '/Contracts_Maintenance', params: {} }
            ],
            cardSize: {
                lg: 3,
                md: 5,
                sm: 5,
                xs: 12
            },
            itemSize: {
                lg: 12,
                md: 6,
                sm: 6,
                xs: 6
            }
        },

        {
            title: 'Review',
            itemSize: {
                lg: 6,
                md: 6,
                sm: 6,
                xs: 6
            },
            cardSize: {
                lg: 3,
                md: 7,
                sm: 7,
                xs: 12
            },
            // path: '/parts',
            // background: 'linear-gradient(110deg,#1D976C 40%,#93F9B9 100%)',
            items: [
                {
                    label: 'Job',
                    value: dashboardData.jobsToReview,
                    path: '/serviceagent/FR',
                    params: {}
                    // search: `?fromDash=true&start=&end=&scheduleEventName=Summer Service`
                },
                { label: 'Events', value: dashboardData.eventsToReview, path: '/Inspection_Awaiting_Sign_Off', lg: 4, params: {} },
                {
                    label: 'FI Completed',
                    value: dashboardData.factoryInspectionCompleted,
                    // valueColor: 'red',
                    path: '/serviceagent/FC',

                    params: {}
                },
                {
                    label: 'OffHire Completed',
                    value: dashboardData.offHireCompleted,
                    // valueColor: 'red',
                    path: '/serviceagent/FI',

                    params: {}
                }
            ]
        },
        {
            title: 'WAREHOUSE',
            // path: '/parts',
            items: [
                { label: 'Parts', value: dashboardData.warehouseQty, path: '/parts', params: {} },
                { label: 'On Order', value: dashboardData.warehouseOnOrder, path: '/parts', params: {} },
                {
                    label: 'In Transit',
                    value: dashboardData.warehouseInTransit || 0,
                    fontWeight: dashboardData.warehouseInTransit > 0 ? 800 : '',
                    valueColor: dashboardData.warehouseInTransit > 0 ? 'red' : 'black',
                    path: '/ProductShipments'
                },
                { label: 'Back Order', value: dashboardData.warehouseBackOrder, path: '/parts', params: {} }
            ],
            itemSize: {
                lg: 6,
                md: 3,
                sm: 3,
                xs: 6
            },
            cardSize: {
                lg: 3,
                md: 12,
                sm: 12,
                xs: 12
            }
        },
        {
            title: 'EVENTS',
            lg: 9,
            innerItem: 3,
            // path: '/parts',
            // background: 'linear-gradient(110deg,#1D976C 40%,#93F9B9 100%)',
            itemSize: {
                lg: 3,
                md: 3,
                sm: 3,
                xs: 6
            },
            cardSize: {
                lg: 12,
                md: 12,
                sm: 12,
                xs: 12
            },
            items: [
                {
                    label: 'Summer Service',
                    value: dashboardData.eventsSummerService,
                    path: '/schedule/confirmedbookings',
                    search: `?fromDash=true&start=&end=&scheduleEventName=Summer Service`,
                    params: {}
                    // params: { scheduleEventName: 'Summer Service' }
                },
                {
                    label: 'On Hire Inspection',
                    value: dashboardData.eventsOnHire,
                    path: '/schedule/confirmedbookings',
                    search: `?fromDash=true&start=&end=&scheduleEventName=On Hire Inspection`,
                    params: {}
                    // params: { scheduleEventName: 'On Hire' }
                },
                {
                    label: 'Off Hire Inspection',
                    value: dashboardData.eventsOffHire,
                    path: '/schedule/confirmedbookings',
                    search: `?fromDash=true&start=&end=&scheduleEventName=Off Hire Inspection`,
                    params: {}
                    // params: { scheduleEventName: 'Off Hire' }
                },
                {
                    label: 'Inspections Current & Past Week',
                    value: dashboardData.eventsInspectionsCurrent,
                    path: '/schedule/confirmedbookings',
                    search: `?fromDash=true&start=&end=${moment().endOf('isoWeek').format('YYYY-MM-DD')}&scheduleEventName=Inspections Current & Past Week`,
                    params: {}
                    // params: { scheduleEventName: 'DOT' }
                },
                {
                    label: 'Inspections Next week',
                    value: dashboardData.eventsInspectionsNextWeek,
                    path: '/schedule/confirmedbookings',
                    search: `?fromDash=true&start=${moment().add(1, 'weeks').startOf('isoWeek').format('YYYY-MM-DD')}&end=${moment()
                        .add(1, 'weeks')
                        .endOf('isoWeek')
                        .format('YYYY-MM-DD')}&scheduleEventName=Inspections Next week`,
                    params: {}
                    // params: { scheduleEventName: '' }
                },
                {
                    label: ' Tachograph Calibration',
                    value: dashboardData.eventsTachographEvents,
                    path: '/schedule/confirmedbookings',
                    search: `?fromDash=true&start=&end=${moment().add(8, 'weeks').endOf('isoWeek').format('YYYY-MM-DD')}&scheduleEventName=Tachograph Cali`,
                    params: {}
                    // params: { scheduleEventName: 'Tachograph' }
                },
                {
                    label: 'Conformity Check',
                    value: dashboardData.eventsConformityCheckEvents,
                    path: '/schedule/confirmedbookings',
                    search: `?fromDash=true&start=&end=${moment().add(4, 'weeks').endOf('isoWeek').format('YYYY-MM-DD')}&scheduleEventName=Conformity Check`,
                    params: {}
                    // params: { scheduleEventName: 'Conformity' }
                },
                {
                    label: 'MOT',
                    value: dashboardData.eventsMOT,
                    path: '/schedule/confirmedbookings',
                    search: `?fromDash=true&start=&end=${moment().add(8, 'weeks').endOf('isoWeek').format('YYYY-MM-DD')}&scheduleEventName=MOT`,
                    params: {}
                    // params: { scheduleEventName: 'MOT' }
                }
            ]
        }
    ];

    const ListCard = [
        {
            Maintitle: `Hire Fleet `,

            overAllItems: [
                { title: 'Hired', value: dashboardData.hireActive, path: '/Contracts_Hire_Fleet', params: {} },
                { title: 'Free stock', value: dashboardData.freeStock, path: '/Contracts_Hire_Fleet', search: '?isFreeStock=true', params: {} }
            ],

            items: [
                {
                    label: 'Awaiting summer service',
                    value: dashboardData.awaitingSummerServiceCount,
                    path: `/ContractStatus/${1}`
                    // params: {}
                    // search: `?status=Awaiting summer service&isSetAll=true`
                    // params: { scheduleEventName: 'On Hire' }
                },
                {
                    label: 'Summer service completed',
                    value: dashboardData.summerServiceCompletedCount,
                    path: `/ContractStatus/${2}`
                    // params: {}
                    // search: `?status=Summer service completed&isSetAll=true`
                    // params: { scheduleEventName: 'Off Hire' }
                },
                {
                    label: 'Delivery Arranged',
                    value: dashboardData.awaitingDeliveryCount,
                    path: `/ContractStatus/${3}`
                    // params: {}
                    // search: `?status=Awaiting Delivery`
                },
                {
                    label: 'In transit',
                    value: dashboardData.collectedCount,
                    path: `/ContractStatus/${4}`
                    // params: {}
                    // search: `?status=In transit`
                },
                {
                    label: 'Vehicle on site (awaiting On hire)',
                    value: dashboardData.vehicleOnsiteCount,
                    path: `/ContractStatus/${5}`
                    // params: {}
                    // path: '/Contracts_Hire_Fleet'
                    // search: `?status=Vehicle on site`
                    // params: { scheduleEventName: 'Tachograph' }
                },
                // {
                //     label: 'Free stock',
                //     value: dashboardData.freeStock,
                //     path: '/schedule/confirmedbookings',
                //     search: `?fromDash=true&start=&end=${moment().add(4, 'weeks').endOf('isoWeek').format('YYYY-MM-DD')}&scheduleEventName=Conformity Check`
                //     // params: { scheduleEventName: 'Conformity' }
                // },
                {
                    label: 'On Hire',
                    value: dashboardData.onHireCount,
                    // value2: dashboardData.offHireCount,
                    path: `/ContractStatus/${6}`
                    // path2: `/ContractStatus/${7}`
                },
                {
                    label: 'Off hired (awaiting offhire)',
                    value: dashboardData.offHireCount,
                    // path: '/Contracts_Hire_Fleet',
                    // search: `?status=Off hire`
                    path: `/ContractStatus/${7}`
                    // params: {}
                    // params: { scheduleEventName: 'MOT' }
                },
                {
                    label: 'Ready to collect',
                    label2: 'Collection arranged',
                    value: dashboardData.readyforcollectionCount,
                    path: `/ContractStatus/${8}`,
                    value2: dashboardData.collectionArrangedCount,
                    path2: `/ContractStatus/${9}`

                    // params: {}
                    // path: '/Contracts_Hire_Fleet',
                    // search: `?status=Ready for collection`
                    // params: { scheduleEventName: 'MOT' }
                },
                // {
                //     label: 'Collection arranged',
                //     value: dashboardData.collectionArrangedCount,
                //     path: `/ContractStatus/${9}`
                //     // params: {}
                //     // path: '/Contracts_Hire_Fleet',
                //     // search: `?status=Collection arranged`
                //     // params: { scheduleEventName: 'MOT' }
                // },
                {
                    label: 'Awaiting factory inspection',
                    value: dashboardData.awaitingFactoryInspectionCount,
                    path: `/ContractStatus/${10}`
                    // params: {}
                    // path: '/Contracts_Hire_Fleet',
                    // search: `?status=Awaiting factory inspection`
                    // params: { scheduleEventName: 'MOT' }
                },
                {
                    label: 'Factory inspection complete',
                    value: dashboardData.factoryInspectionCount,
                    path: `/ContractStatus/${11}`
                    // params: {}
                    // path: '/Contracts_Hire_Fleet',
                    // search: `?status=Awaiting factory inspection`
                    // params: { scheduleEventName: 'MOT' }
                }
            ]
        }
    ];

    let MyReportList = [
        {
            value: 'VOR',
            name: ' Reporting',
            path: '/controller/VorReporting/'
        },
        {
            value: 'Breakdown',
            name: 'Reporting ',
            path: '/maintenance/breakdown/reporting/'
        },
        {
            value: 'Job',
            name: ' Reporting ',
            path: '/job/job_Reporting'
        },
        {
            value: 'My Reports',
            name: ' Reporting ',
            path: '/reports/reportlist/'
        }
    ];

    return (
        <div style={{ padding: 10 }}>
            <MainDashboard
                // singleCardData={singleCardData}
                groupCardData={groupCardData}
                loading={loading}
                pullDashboardData={pullDashboardData}
                singleServiceGrpupCardData={singleGrpupCardData}
                MyServiceReportList={MyReportList}
                ListCard={ListCard}
                isServiceArea={true}
            />
        </div>
    );
};
export default ServiceAgentDash;
